import { ValidatorFn, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/validators/custom-validators.validators';

type AdresseValidationConfig = {
  codePostal: ValidatorFn[];
  province: ValidatorFn[];
  ville: ValidatorFn[];
};

export const ADRESSE_VALIDATION_CONFIG: Record<string, AdresseValidationConfig> = {
  ca: {
    codePostal: [],
    province: [Validators.required],
    ville: [Validators.required, Validators.maxLength(30), CustomValidators.caracteresAccesDValide],
  },
  us: {
    codePostal: [],
    province: [Validators.required],
    ville: [
      Validators.required,
      Validators.maxLength(15),
      CustomValidators.villeSansVirgule,
      CustomValidators.caracteresAccesDValide,
    ],
  },
  mx: {
    codePostal: [],
    province: [Validators.required],
    ville: [
      Validators.required,
      Validators.maxLength(15),
      CustomValidators.villeSansVirgule,
      CustomValidators.caracteresAccesDValide,
    ],
  },
  autre: {
    codePostal: [Validators.maxLength(10), CustomValidators.caracteresAccesDValide],
    province: [],
    ville: [
      Validators.required,
      Validators.maxLength(15),
      CustomValidators.villeSansVirgule,
      CustomValidators.caracteresAccesDValide,
    ],
  },
};
